import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import { JWTService } from '@/shared/services/jwt'
import download from 'downloadjs'

import AutoTypeRepository from '@/shared/http/repositories/configuration/autotype'
import AutoModelRepository from '@/shared/http/repositories/configuration/automodel'
import BrandRepository from '@/shared/http/repositories/configuration/brand'

import Datepicker from 'vuejs-datepicker'
import {VMoney} from 'v-money'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

import SinisterHeader from '@/components/regulation/auto/sinisterheader/sinisterheader.vue'
import SinisterWorkshopReturnModel from '@/shared/models/regulation/auto/sinisterworkshopreturn-model'

import SinisterValues from './values/SinisterValues.vue'

import RegulationWorkshopReturnRepository from '@/shared/http/repositories/regulation/auto/regulationautoworkshopreturn'
import RegulationImageRepository from '@/shared/http/repositories/regulation/auto/regulationautoimage'
import RegulationBudgetRepository from '@/shared/http/repositories/regulation/auto/regulationautobudget'

import ExpertMixin from '@/store/module/expert/mixin.js'
import RegulationMixin from '@/store/module/regulation/mixin'
import SinisterWorkshopReturnForm from './sinisterworkshopreturn-form'

export default {
  name: 'SinisterWorkshopReturn',
  props: [ 'clear' ],
  directives: {money: VMoney},
  mixins: [
    ActionsForm,
    ExpertMixin,
    RegulationMixin
  ],
  data () {
    return {
      imageId: null,
      data: SinisterWorkshopReturnModel,
      form: SinisterWorkshopReturnForm,
      en: en,
      es: es,
      ptBR: ptBR,
      album: { titleAlbum: '' },
      ImageTypeMnemonic: 'OUTROS',
      images: [],
      budgets: [],
      files: [],
      isShowingAlbums: false,
      isShowingImages: false,
      isShowingImagesCarousel: false,
      slide: 0,
      slide2: 0,
      sliding: null,
      moneyFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      STG_FRUSTRATED: false,
      STG_CANCELED: false
    }
  },
  components: {
    Datepicker,
    SinisterHeader,
    SinisterValues,
    AutoTypeRepository,
    AutoModelRepository
  },
  watch: {
    // TODO RETIRAR APÓS REFACTOR
    clear: function () {
      this.onClear()
    }
  },
  mounted () {
    this.onLoadAllAutoType()
  },
  created () {
  },
  computed: {
    totalBudgeted: function () {
      return (Number(this.form.valueBodywork.value) + Number(this.form.valueTapestry.value) + Number(this.form.valuePainting.value) + Number(this.form.valueGlassware.value) + Number(this.form.valueElectrical.value) + Number(this.form.valueMechanical.value) + Number(this.form.valueThird.value))
    },
    getAllExpert: function () {
      var result = []
      if ((this.experts) && (this.experts.count) > 0) {
        var data = this.experts.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.expertID.options = result
      }
      return result
    }
  },
  methods: {
    LoadImages () {
      this.images = []
      RegulationImageRepository.GetAll(this.regulation.id)
        .then((response) => {
          this.images = response.data.data
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    LoadBudgets () {
      this.budgets = []
      RegulationBudgetRepository.GetAll(this.regulation.id)
        .then((response) => {
          this.budgets = response.data.data
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    onClear () {
      var self = this
      Tools.SetFormDefaultValues(self.form)
      // TODO PADRONIZAR LIMPEZA DOS FORMS DA TELA DE SINISTRO
      setTimeout(() => {
        if (!!this.regulation && !!this.regulation.id) {
          self.form.regulationAutoID.value = this.regulation.id
        }
        if (self.data.id && self.data.id !== '00000000-0000-0000-0000-000000000000') {
          self.form.id.value = self.data.id
        }
      }, 1000)
    },
    onSave () {
      var self = this
      this.form.regulationAutoID.value = this.regulation.id
      if (Tools.ValidateForms(this.form, this.data, self)) {
        // Set default data
        this.data.dateUpdate = this.moment().format('YYYY-MM-DD hh:mm:ss')
        this.data.accountIDUpdate = JWTService.GetTokenPayload().AccountID
        if (this.data.hasOwnProperty('companyID')) {
          this.data.companyID = JWTService.GetTokenPayload().companyID
        }

        if (this.data) {
          if (this.data.id !== null && this.data.id !== '00000000-0000-0000-0000-000000000000') {
            this.onUpdate()
          } else {
            this.data.id = '00000000-0000-0000-0000-000000000000'
            this.data.status = 1
            this.onCreate()
          }
        } else {
          toast.error(this.$lang.Common.NoRecordInformed)
        }
      }
    },
    onCreate () {
      loading.push()
      RegulationWorkshopReturnRepository.Create(this.data)
        .then((response) => {
          var result = this.onResultObj(response)
          if (result !== null) {
            this.form.id.value = result.id
          }
          this.onResult(response, true, true)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      RegulationWorkshopReturnRepository.Update(this.data)
        .then((response) => {
          this.onResult(response, true, true)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoad (regulation) {
      if (regulation) {
        this.regulation = regulation
        this.onEdit()
        this.LoadImages()
        this.LoadBudgets()
      }
    },
    onEdit () {
      this.onClear()
      var self = this
      RegulationWorkshopReturnRepository.GetByRegulationAutoID(this.regulation.id)
        .then((response) => {
          var result = response.data.data
          if (result) {
            Tools.SetValueInForm(self.form, self.data, result)
            this.STG_FRUSTRATED = (result.regulationAutoSchedulingStatus && result.regulationAutoSchedulingStatus.mnemonic === 'STG_FRUSTRATED')
            this.STG_CANCELED = (result.regulationAutoSchedulingStatus && result.regulationAutoSchedulingStatus.mnemonic === 'STG_CANCELED')
            if (result.autoModel) {
              self.setAutoType(result.autoModel.brand.autoTypeID)
                .then(func => self.changeAutoType(result.autoModel.brand.autoTypeID, func))
                .then(func => self.setBrand(result.autoModel.brandID, func))
                .then(func => self.changeBrand(result.autoModel.brandID, func))
                .then(func => self.setAuto(result.autoModel.id, func))
                .catch(function (err) {
                  console.log(err)
                })
            }
          }
        })
        .catch((err) => {
          this.onException(err)
        })
      self.form.regulationAutoID.value = this.regulation.id
    },
    onChangeAutoType () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllBrand(self.form.autoTypeID.value)
      }, 500)
    },
    onChangeBrand () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllAutoModel(self.form.brandID.value)
      }, 500)
    },
    onLoadAllAutoType () {
      loading.push()
      AutoTypeRepository.GetAll()
        .then((response) => {
          this.form.autoTypeID.options = this.onResultDropdown(response, true)
        })
        .catch((err) => {
          this.onException(err)
        })
      this.form.autoTypeID.value = null
    },
    onLoadAllBrand (typeID) {
      this.form.brandID.options = []
      this.form.autoModelID.options = []
      if (typeID) {
        loading.push()
        BrandRepository.GetAllByAutoTypeID(typeID)
          .then((response) => {
            this.form.brandID.options = this.onResultDropdown(response, true)
          })
          .catch((err) => {
            this.onException(err)
          })
        this.form.brandID.value = null
      }
    },
    onLoadAllAutoModel (brandID) {
      this.form.autoModelID.options = []
      if (brandID) {
        loading.push()
        AutoModelRepository.GetAllByBrandID(brandID)
          .then((response) => {
            this.form.autoModelID.options = this.onResultDropdown(response, true)
          })
          .catch((err) => {
            this.onException(err)
          })
        this.form.autoModelID.value = null
      }
    },
    onDelete (obj) {
      loading.push()
      RegulationWorkshopReturnRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    downloadImages () {
      loading.push()
      if (this.regulation) {
        RegulationImageRepository.DownloadImages(this.regulation.id)
          .then((response) => {
            var file = response.data.data
            var base64 = 'data:' + file.contentType + ';base64,' + file.base64

            download(base64, file.alias, file.contentType)
            loading.pop()
          })
          .catch((err) => {
            this.onException(err)
            loading.pop()
          })
      } else {
        loading.pop()
      }
    },
    downloadBudgets () {
      loading.push()
      if (this.regulation) {
        RegulationBudgetRepository.DownloadBudgets(this.regulation.id)
          .then((response) => {
            var file = response.data.data
            var base64 = 'data:' + file.contentType + ';base64,' + file.base64

            download(base64, file.name, file.contentType)
            loading.pop()
          })
          .catch((err) => {
            this.onException(err)
            loading.pop()
          })
      } else {
        loading.pop()
      }
    },
    setBrand (brandID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.brandID.value = brandID
          resolve()
        }, 200)
      })
    },
    setAuto (autoModelID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.autoModelID.value = autoModelID
          resolve()
        }, 300)
      })
    },
    addFiles () {
      this.$refs.files.click()
    },
    addFilesBudgets () {
      this.$refs.budgets.click()
    },
    onUploadImage () {
      loading.push()
      const files = this.$refs.files.files
      let formData = new FormData()
      for (var i = 0; i < files.length; i++) {
        formData.append('files[' + i + ']', files[i])
      }
      RegulationImageRepository.Upload(this.regulation.id, this.ImageTypeMnemonic, formData)
        .then((response) => {
          this.LoadImages()
          this.onResult(response)
          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUploadBudget () {
      loading.push()
      const budgets = this.$refs.budgets.files
      console.log(budgets)
      let formData = new FormData()
      for (var i = 0; i < budgets.length; i++) {
        formData.append('budgets[' + i + ']', budgets[i])
      }
      RegulationBudgetRepository.Upload(this.regulation.id, formData)
        .then((response) => {
          this.LoadBudgets()
          this.onResult(response)
          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    getPath (path, fileName) {
      let pathURL = process.env.FileStorageURL + path + '/' + fileName
      let segmentsURL = path.split('/')
      if (segmentsURL[segmentsURL.length - 1] !== 'picture') {
        pathURL = `${path}/${fileName}`
      }
      return pathURL
    },
    getPathBudget (path, fileName) {
      let pathURL = process.env.FileStorageURL + path + '/' + fileName
      let segmentsURL = path.split('/')
      if (segmentsURL[segmentsURL.length - 1] !== 'budget') {
        pathURL = `${path}/${fileName}`
      }
      return pathURL
    },
    onDeleteImage (id) {
      loading.push()
      RegulationImageRepository.Delete(id)
        .then((response) => {
          this.onResult(response)
          this.LoadImages()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDeleteBudget (id) {
      loading.push()
      RegulationBudgetRepository.Delete(id)
        .then((response) => {
          this.onResult(response)
          this.LoadBudgets()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    changeAutoType (autoTypeID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.brandID.options = []
          self.form.autoModelID.options = []
          loading.push()
          BrandRepository.GetAllByAutoTypeID(autoTypeID)
            .then((response) => {
              self.form.brandID.options = self.onResultDropdown(response, true)
            })
            .catch((err) => {
              self.onException(err)
            })
          resolve()
        }, 200)
      })
    },
    setAutoType (autoTypeID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.autoTypeID.value = autoTypeID
          resolve()
        }, 200)
      })
    },
    changeBrand (brandID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.autoModelID.options = []
          loading.push()
          AutoModelRepository.GetAllByBrandID(brandID)
            .then((response) => {
              self.form.autoModelID.options = self.onResultDropdown(response, true)
            })
            .catch((err) => {
              self.onException(err)
            })
          resolve()
        }, 800)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/workshopreturn/sinisterworkshopreturn.js